import type { Contributor } from "../types/api";

/**
 * Where a contributor belongs right now.
 *
 * Onboarding state is the single source of truth, so a half-finished signup
 * resumes at the right step whichever way they arrive — fresh login, reload,
 * or a bookmarked deep link.
 */
export function routeForContributor(contributor: Contributor | null): string {
  if (!contributor) return "/login";
  const onboarding = contributor.onboarding;
  if (!onboarding || onboarding.completed) return "/record";
  // Terms are agreed to during signup, so this is only reached when the
  // agreement has been revised and everyone has to accept the new wording.
  if (!onboarding.terms_accepted) return "/onboarding/terms";
  if (!onboarding.profile_completed) return "/onboarding/profile";
  return "/onboarding/finish";
}
